<template>
  <div>
    <Header></Header>
    <v-container fluid grid-list-xl class="margin-top-50px">
      <v-layout row>
        <v-flex xs12 xl12 md12 sm12 lg12 class="mt-4">
          <div class="title text-xs-center form-divider">ثبت نقطه جدید</div>
        </v-flex>
      </v-layout>
      <v-form ref="NewSystemUserForm" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm6 md6 xl6 lg6>
            <v-text-field
              :rules="nameRule"
              v-model="name"
              solo
              placeholder="نام نقطه جدید را وارد کنید"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md6 xl6 lg6>
            <v-select :items="ss" placeholder="مکان نقطه را مشخص کنید"></v-select>
          </v-flex>
          <v-flex xs12 sm6 md6 xl6 lg6>
            <v-select :items="ds" placeholder="نوع نقطه را مشخص کنید"></v-select>
          </v-flex>

          <v-flex xs12 sm6 md6 xl6 lg6>
            <v-btn block color="indigo" dark @click="done(name)">
              <v-icon>done</v-icon>ثبت
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 md6 xl6 lg6>
            <v-text-field
              :rules="nameRule"
              v-model="name"
              solo
              type="number"
              placeholder="نام نقطه جدید را وارد کنید"
              hint="فقط حروف فارسی پشتیبانی میشود"
              append-icon="account_circle"
              clearable
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import Header from "@/components/dashboard/Header";
import Api from "@/services/Api";

export default {
  data() {
    return {
      name: "",
      nameRule: [v => !!v || "این فیلد اجباری است"],
      msg: "",
      userDataTableLoading: true,
      tabItems: [
        { title: "کلاس فعال", path: "Users", icon: "account_circle" },
        {
          title: "کلاس حذف شده",
          path: "BlockedUsers",
          icon: "delete",
          method: "getDeletedUsers"
        }
      ],
      classTableHeader: [
        { text: "#", sortable: false, value: "counter", align: "right" },
        { text: "نام کلاس ", sortable: false, value: "User", align: "right" }
      ]
    };
  },
  components: {
    Header
  },
  methods: {
    async done(name) {
      try {
        let response;
        response = await Api().post("classification/insert", name);
        if (response == 1) {
          this.msg = "موفقیت آمیز";
        } else if (response == 0) {
          this.msg = "ناموفق";
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.margin-top-50px {
  margin-top: 50px;
}
</style>
